import { useCallback, useEffect, useState } from "react";
import { fetchCourseProgressMap } from "@/services/courseProgress";

export type UseCourseProgressState = {
  /** course_id ("c1".."c6") -> % de progreso (0-100). */
  progressByCourseId: Map<string, number>;
  loading: boolean;
  /** Vuelve a pedir el progreso a Supabase (ej. después de completar una lección). */
  refresh: () => void;
};

/**
 * Carga el % de progreso por curso del usuario autenticado, desde la tabla
 * course_progress de Supabase. Se usa en Cursos, Mi Ruta y Perfil para que
 * las tres pantallas muestren siempre el mismo progreso.
 */
export function useCourseProgress(): UseCourseProgressState {
  const [progressByCourseId, setProgressByCourseId] = useState<Map<string, number>>(new Map());
  const [loading, setLoading] = useState(true);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchCourseProgressMap().then((map) => {
      if (!cancelled) {
        setProgressByCourseId(map);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [reloadToken]);

  const refresh = useCallback(() => setReloadToken((t) => t + 1), []);

  return { progressByCourseId, loading, refresh };
}
